(ns app.bulk.unsaved-guard
  "Browser navigation guards for unsaved bulk scheduling changes."
  (:require [app.bulk.page :as bulk-page]
            [app.bulk.unsaved-confirm-modal :as unsaved-confirm-modal]
            [clojure.string :as str]))

(defn add-unsaved-guard!
  "Installs a capture-phase click listener that blocks SPA / external
   link navigation away from `/ui/bulk` while the page has unsaved row
   edits. When triggered, opens the bulk-unsaved confirm modal with the
   target URL deferred for `:bulk/discard-and-navigate`."
  [{:keys [ui/store] :as w}]
  (js/document.body.addEventListener
    "click"
    (fn [event]
      (when (and (= :pages/bulk
                    (get-in @store [:location :location/page-id]))
                 (bulk-page/unsaved-changes-in-state? @store)
                 (not (.-shiftKey event))
                 (not (.-metaKey event))
                 (not (.-ctrlKey event)))
        (when-let [a (some-> event .-target (.closest "a"))]
          (when-let [href (some-> a (.getAttribute "href"))]
            (when-not (or (str/starts-with? href "#")
                          (str/starts-with? href "/ui/bulk"))
              (.preventDefault event)
              (.stopImmediatePropagation event)
              (swap! store
                     assoc
                     :ui/modal
                     {:modal-id :modals/bulk-unsaved-confirm
                      :params {:on-confirm
                               [[:bulk/discard-and-navigate href]]}
                      :render unsaved-confirm-modal/render}))))))
    true)
  w)

(defn add-beforeunload!
  "Native beforeunload prompt for tab close / hard reload while bulk has
   unsaved row edits. The browser shows its own modal; we cannot inject
   the styled Replicant one here because the page is leaving."
  [{:keys [ui/store] :as w}]
  (js/window.addEventListener
    "beforeunload"
    (fn [e]
      (when (and (= :pages/bulk
                    (get-in @store [:location :location/page-id]))
                 (bulk-page/unsaved-changes-in-state? @store))
        (.preventDefault e)
        (set! (.-returnValue e)
              "You have unsaved changes. Leave anyway?"))))
  w)

(defn add-guards!
  [w]
  (-> w
      (add-unsaved-guard!)
      (add-beforeunload!)))
